import { useRef } from 'react';
import {
  Box, Container, Wrap, Text,
} from '@chakra-ui/react';

import MainLayout from '@src/components/layouts/main';
import Pagination from '../../components/Pagination';
import PrintablePdf from '../../components/PrintablePdf';
import RoadSafetyNetwork from './components/report-sections/RoadSafetyNetwork';
import RoadSafetyByMode from './components/report-sections/RoadSafetyByMode';
import RoadSafetyReportHeader from './components/report-headers/RoadSafetyReportHeader';
import DataDisclaimer from '../../components/DataDisclaimer';
import RoadSafetyDsi from './components/report-sections/RoadSafetyDsi';
import RoadSafetyCrashDistributionStreetCategories from './components/report-sections/RoadSafetyCrashDistributionStreetCategories';
import RoadSafetyCrashDistributionFreight from './components/report-sections/RoadSafetyCrashDistributionFreight';
import RoadSafetyCrashDistributionGeneralTraffic from './components/report-sections/RoadSafetyCrashDistributionGeneralTraffic';
import RoadSafetyRoadAssessmentRating from './components/report-sections/RoadSafetyRoadAssessmentRating';
import RoadSafetyCrashConditions from './components/report-sections/RoadSafetyCrashConditions';
import RoadSafetyCrashFactors from './components/report-sections/RoadSafetyCrashFactors';

function RoadSafety() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Road Safety"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <Text mb={4}>
              This page provides annual reporting on vehicle crashes, injuries and deaths on the roads in this network.
            </Text>
          )}
        />
        <Box ref={printableRef}>
          <RoadSafetyReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <RoadSafetyDsi />
            <RoadSafetyNetwork />
            <RoadSafetyCrashFactors />
            <RoadSafetyByMode />
            <RoadSafetyCrashConditions />
            <RoadSafetyRoadAssessmentRating />
            <RoadSafetyCrashDistributionGeneralTraffic />
            <RoadSafetyCrashDistributionFreight />
            <RoadSafetyCrashDistributionStreetCategories />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default RoadSafety;
